import { formatUtils } from "@/utils";

export const getValueByFormat = (
  format: any,
  locale: string = "fr",
  currency: string = "EUR",
  newValue: number
) => {
  if (format == formatUtils.formatIntegerCurrency) {
    return formatUtils.formatIntegerCurrency(newValue, locale, currency);
  }
  return format(newValue);
};
